import { cn } from "@/shared/lib/utils";
import TypographyMuted from "../Typographies/Muted";
import TypographyH1 from "../Typographies/Title1";
import { BackButton } from "./BackButton";
import FavoriteStar from "./FavoriteStar";

type PageHeaderProps = {
  title: React.ReactNode
  icon?: React.ReactNode
  description?: React.ReactNode
  titleUppercase?: boolean
  titleSmaller?: boolean
  className?: string
  actions?: React.ReactNode
  backPath?: string
  backPathLegend?: string
};

const PageHeader = ({
  title,
  icon,
  description,
  titleUppercase,
  titleSmaller,
  className,
  actions,
  backPath,
  backPathLegend,
}: PageHeaderProps) => {
  return (
    <div className={cn("flex flex-col my-6", className)}>
      <div className="flex items-start justify-between">
        <div className="flex flex-col">
          <div className="flex items-center gap-2">
            {backPath && <BackButton to={backPath} legend={backPathLegend} />}
            <FavoriteStar />
            <TypographyH1
              icon={icon}
              uppercase={titleUppercase}
              smaller={titleSmaller}
              className={cn(icon && "flex items-center gap-2")}
            >
              {title}
            </TypographyH1>
          </div>
          {description && <TypographyMuted className="mt-1" text={description} />}
        </div>
        {actions && (
          <div className="flex items-center gap-2 ml-4">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
